import UserDeactiveIcon from "../icons/UserDeactiveIcon";
import { useSession } from "next-auth/react";
import { useImageLockedCountByUser } from "@/hooks/image/useImageLockedCountByUser";

export const UserDeActiveLink = () => {
  const { data: session } = useSession();
  const user = session?.user;

  const { lockedCount, isError, isLoading } = useImageLockedCountByUser(
    user?.id ? { userUuid: user.id } : null
  );

  if (isLoading || isError) {
    return <UserDeactiveIcon />;
  }

  if (lockedCount < 1) {
    return <UserDeactiveIcon />;
  }

  return <UserDeactiveIcon notificationCount={lockedCount} />;
};

export default UserDeActiveLink;